<template>
	<section class="oxigrafia inner-screen">
		<video-page :data="data"></video-page>
	</section>	
</template>

<script>
import VideoPage from './VideoPage'
import crayon from '../assets/img/tools/crayon.png';
import ximiko_dialyma from '../assets/img/tools/ximiko_dialyma.png';
import dialitis from '../assets/img/tools/dialitis.png';
import water from '../assets/img/tools/water.png';
import ink_roller from '../assets/img/tools/ink_roller.png';
import litho_press from '../assets/img/tools/litho_press.png';
import video1 from './../assets/videos/litho/litho_001.mp4';
import video2 from './../assets/videos/litho/litho_002.mp4';
import video3 from './../assets/videos/litho/litho_003.mp4';
import video4 from './../assets/videos/litho/litho_004.mp4';
import video5 from './../assets/videos/litho/litho_005.mp4';
import video6 from './../assets/videos/litho/litho_006.mp4';

export default {
  name: 'lithografia',
  components: {
    VideoPage
  },
  created: function() {
      window.document.title = "ΛΙΘΟΓΡΑΦΙΑ - ΤΡΑΠΕΖΑ ΤΗΣ ΕΛΛΑΔΟΣ";
  },
  data () {
    return {
      data: {
      	stepcount: 7,
      	step_icons: [
      		{src: crayon},
      		{src: ximiko_dialyma},
      		{src: dialitis},
          {src: water},
          {src: ink_roller},
          {src: litho_press},
      	],
      	videos: [
      		{src: video1},
      		{src: video2},
      		{src: video3},
      		{src: video4},
          {src: video5},
          {src: video6},
      	],
      	description: [
      		{text: 'Ο χαράκτης σχεδιάζει τη σύνθεση στη  λιθογραφική πλάκα με ειδικά λιθογραφικά κραγιόνια, τα οποία είναι λιπαρά. '},
      		{text: 'Η πλάκα καλύπτεται με ειδική ουσία (αραβική γόμα), η οποία θα βοηθήσει το λιπαρό σχέδιο να απορροφήσει  το μελάνι που θα περαστεί μετά. Οι καθαρές επιφάνειες δεν θα απορροφήσουν μελάνι αλλά μόνο νερό.'},
      		{text: 'Ο χαράκτης έπειτα θα καθαρίσει την επιφάνεια με νέφτι και νερό. Το σχέδιο ενσωματώνεται στην πλάκα, τώρα φαίνεται πιο αχνό όμως το λίπος από τα κραγιόνια στο σχέδιο έχει παραμείνει.'},
      		{text: 'Η λιθογραφική πλάκα βρέχεται.'},
          {text: 'Έπειτα η επιφάνεια της πλάκας μελανώνεται με τον κύλινδρο μελανώματος. Το μελάνι είναι λιπαρό, πράγμα που σημαίνει ότι θα συγκρατηθεί μόνο από το λιπαρό σχέδιο και θα αποβληθεί από την υπόλοιπη επιφάνεια της πλάκας που έχει συγκρατήσει το νερό.  Αυτό συμβαίνει επειδή το νερό και το λάδι δεν ‘’ενώνονται’’.'},
          {text: 'Η πλάκα μελανωμένη πλέον, τοποθετείται στη λιθογραφική πρέσα με ένα φύλλο χαρτί από πάνω το οποίο πιεζόμενο ‘’παίρνει’’ το μελάνι από τη λιθογραφική επιφάνεια. Το πρώτο λιθογραφικό αντίτυπο (λιθογραφία) είναι έτοιμο. Η διαδικασία, βρέξιμο – μελάνωμα – τύπωμα, επαναλαμβάνεται ανάλογα με τα αντίτυπα που χρειάζονται.'}
      	]
      }
    }
  },
  mounted: function() {
      this.$emit('hideLoader')
  }
}
</script>


// WEBPACK FOOTER //
// Lithografia.vue?09fedd38